import bcrypt from 'react-native-bcrypt';

import {LOGIN_TYPE} from '/enum/biometrics.enum';
import {hashPin} from '/util/bcrypt.util';
import {getBiometricsUtilDefaultInstance} from '/util/biometrics/biometrics.util';

export const storeEncryptedPin =
  ({pin, setUserPinValue}: any) =>
  () => {
    let hash = hashPin(pin, 8);
    return setUserPinValue(hash);
  };
export const handlePinOptIn =
  ({pin, setUserPinValue}: any) =>
  () => {
    let hash = hashPin(pin, 8);
    return setUserPinValue(hash);
  };
export const checkPin =
  ({pin, getUserPinValue, handlePinLogin, setValue, handleOnSubmit}: any) =>
  () => {
    getUserPinValue().then((val: any) =>
      bcrypt.compare(pin, val, function (err: any, res: any) {
        if (res) {
          // hidePopup();
          handlePinLogin({setValue, handleOnSubmit})();
        } else {
          return err;
        }
      }),
    );
  };
export const handleTurnOffBiometrics =
  ({
    pin,
    getUserPinValue,
    hidePopup,
    setBiometricsOptInValue,
    setBiometricsOptIn,
  }: any) =>
  () => {
    getUserPinValue().then((val: any) =>
      bcrypt.compare(pin, val, function (err: any, res: any) {
        if (res) {
          return setBiometricsOptInValue(false)
            .then(() => setBiometricsOptIn(false))
            .then(() => hidePopup());
        } else {
          return err;
        }
      }),
    );
  };
export const handleTurnOffPin =
  ({pin, getUserPinValue, hidePopup, setPinOptInValue, setPinOptIn}: any) =>
  () => {
    getUserPinValue().then((val: any) =>
      bcrypt.compare(pin, val, function (err: any, res: any) {
        if (res) {
          return setPinOptInValue(false)
            .then(() => setPinOptIn(false))
            .then(() => hidePopup());
        } else {
          return err;
        }
      }),
    );
  };

export const handlePinLogin =
  ({setValue, handleOnSubmit}: any) =>
  () => {
    return getBiometricsUtilDefaultInstance()
      .retrievePassword({setValue, loginType: LOGIN_TYPE.pin})()
      .then(() => handleOnSubmit());
  };
